import {
  BasketballEventDetailId,
  YesNoEnum,
} from '@collector/sportsapi-client-legacy'
import { useSeasonDetails } from '@desktop/views/Relation/composables'

export function useBasketballSeasonDetails(): {
  isFourPointsShotEnabled: boolean
} {
  const { seasonDetailsMap } = useSeasonDetails()

  const isFourPointsShotEnabled =
    seasonDetailsMap.value.get(BasketballEventDetailId.FourPointsShot) ===
    YesNoEnum.Yes

  return { isFourPointsShotEnabled }
}
